import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';
import { LogInOutComponent } from "./security/loginout/loginout.component"

import { HttpService } from './common/http.service';

import { CurrentUserService } from './security/current-user.service';
import { CurrentUserComponent } from "./security/current-user/current-user.component";
import { BrowserCheckComponent } from "./security/browser-check/browser-check.component";
import { AuthFailDialogComponent } from "./security/auth-fail-dialog/auth-fail-dialog.component";
import { CasService } from "./security/cas.service";

import { FacetedSearchAppBannerComponent } from './fsapplication/faceted-search-app-banner/faceted-search-app-banner.component';
import { FacetComponent } from "./fsapplication/facet/facet.component";
import { FacetListComponent } from "./fsapplication/facet-list/facet-list.component";
import { FacetedSearchAppService } from "./fsapplication/webapi/faceted-search-app.service";
import { FacetedSearchAppComponent } from "./fsapplication/faceted-search-app/faceted-search-app.component";
import { SearchResultComponent } from "./fsapplication/search-result/search-result.component";
import { AdminFacetsComponent } from "./fsapplication/admin-facets/admin-facets.component";
import { AdminAppComponent } from "./fsapplication/admin-app/admin-app.component";
import { AdminAboutComponent } from "./fsapplication/admin-about/admin-about.component";
import { PresetSaveDialogComponent } from "./fsapplication/preset-save-dialog/preset-save-dialog.component";
import { PresetComponent } from "./fsapplication/preset/preset.component";
import { AdminPresetsComponent } from "./fsapplication/admin-presets/admin-presets.component";
import { ConfirmationDialogComponent } from "./fsapplication/confirmation-dialog/confirmation-dialog.component";
import { ErrorComponent } from './error/error.component';

import { Globals } from "./common/globals";

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularSplitModule } from 'angular-split';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';

import { TableModule } from 'primeng/components/table/table';



export function httpServiceFactory(backend: XHRBackend, options: RequestOptions, router: Router) {
  options.withCredentials = true;
  return new Http(backend, options);
  //return new HttpService(backend, options, router);
};

@NgModule({
  declarations: [
    AppComponent,
    LogInOutComponent,
    CurrentUserComponent,
    BrowserCheckComponent,
    FacetedSearchAppBannerComponent,
    FacetComponent,
    FacetListComponent,
    FacetedSearchAppComponent,
    SearchResultComponent,
    AuthFailDialogComponent,
    AdminFacetsComponent,
    AdminAppComponent,
    AdminAboutComponent,
    PresetSaveDialogComponent,
    PresetComponent,
    AdminPresetsComponent,
    ConfirmationDialogComponent,
    ErrorComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    AppRoutingModule,
    FormsModule,
    AngularSplitModule,
    BrowserAnimationsModule,
    MatCardModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    TableModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: Http,
      useFactory: httpServiceFactory,
      deps: [XHRBackend, RequestOptions, Router]
    },
    CurrentUserService,
    CasService,
    FacetedSearchAppService
  ],
  entryComponents: [
    AuthFailDialogComponent,
    PresetSaveDialogComponent,
    ConfirmationDialogComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts